import Vue from "vue/dist/vue.min.js";
import resources from "./resources.vue";
import autocompleteWrapper from "./autocompleteWrapper";
import "@babel/polyfill";
import focusTrap from "focus-trap";

new Vue({
  el: "#resourceApp",
  delimiters: ["${", "}"],
  data() {
    return {
      showLoadMore: false,
      elementsPerPage: 10,
      filters: [],
      isDataAvailable: false,
      error: null,
      totalResults: null,
      showFilters: false,
      offcanvasTrap: null,
    };
  },
  components: {
    resources: resources,
    "autocomplete-keywords": autocompleteWrapper,
  },
  mounted: function () {
    this.offcanvasTrap = focusTrap(".resourceApp__sidebar", {
      clickOutsideDeactivates: true,
    });

    //https://vuedose.tips/tips/improve-performance-on-large-lists-in-vue-js/
    //https://premium.wpmudev.org/blog/creating-a-hybrid-single-page-app-wordpress-with-vuejs/
    //https://vuedose.tips/tips/measure-runtime-performance-in-vue-js-apps/

    //check if a page slug exists, and if so set it to the search filters var
    const slug = document.getElementById("resourceApp").dataset
      .targetedResource;
    if (slug) {
      this.keywordsChanged([
        {
          text: slug,
        },
      ]);
    } else {
      //check for any URL params and add them to our filters var
      const urlParams = new URLSearchParams(window.location.search);

      //filters
      if (urlParams.has("filters[]")) {
        let requestedFilters = urlParams.getAll("filters[]");
        this.filters = requestedFilters
          .filter((f) => f !== "")
          .map((f) => JSON.parse(f)); //need to parse the value into actual JSON before adding to filters array
      }

      //search
      if (urlParams.has("search") && urlParams.get("search") !== "") {
        let searchTerm = urlParams.get("search");

        //check if search term matches a keyword supplied to the autocomplete component
        const keywords = this.$refs.autocompleteKeywords.autocompleteItems;
        let matchingKeywords = keywords.filter(
          (item) => item.text === searchTerm
        );
        if (matchingKeywords.length > 0) {
          this.keywordsChanged([matchingKeywords[0]]);
        } else {
          this.keywordsChanged([
            {
              text: searchTerm,
            },
          ]);
        }
      }
    }
  },
  watch: {
    showFilters: function (showing) {
      const body = document.querySelector("body");
      this.$nextTick(() => {
        if (showing) {
          this.offcanvasTrap.activate();
          body.classList.add("u-noScroll");
        } else {
          this.offcanvasTrap.deactivate();
          body.classList.remove("u-noScroll");
        }
      });
    },
    filters: function () {
      //set up new url search params object and add our filters into it
      let filterParams = new URLSearchParams();
      this.filters.forEach((f) => {
        filterParams.append("filters[]", JSON.stringify(f));
      });

      //create a new url object from the current url
      let url = new URL(window.location.href);

      //set the pathname to be just the first 2 elements in the paths array in order to strip out a resource slug if it exists
      let paths = url.pathname.split("/");
      url.pathname = paths.slice(0, 3).join("/"); //set to 0, 3 because the first element in paths is empty

      //sets the query params and replaces the url in the browser
      //@todo Use pushState and implement a two-way syncing between url and filters on 'back'
      url.search = filterParams.toString();
      window.history.replaceState(
        this.filters,
        "Update search filters",
        url.toString()
      ); //replaceState doesn't cause history change
    },
  },
  methods: {
    removeFilter: function (filter) {
      this.filters = this.filters.filter((item) =>
        filter.id ? item.id !== filter.id : item.text !== filter.text
      );
    },
    filtersExist: function (t) {
      const tags = JSON.parse(t);

      return tags.every((tag) => {
        return (
          -1 !==
          this.filters.findIndex(
            (test) => test.id === tag.id && test.text === tag.text
          )
        );
      });
    },
    keywordsChanged: function (keywords) {
      //format into appropriate array of objects then merge into current filters (after stripping out all keywords/search)
      this.filters = keywords
        .map((k) => {
          return {
            text: k.text,
            type: k.id ? "resourceKeywords" : "search",
            id: k.id,
          };
        })
        .concat(
          this.filters.filter(
            (f) => f.type !== "search" && f.type !== "resourceKeywords"
          )
        );
    },
    handleKeywordFilterCheckboxChange: function ($event) {
      //get the value from the checkbox (an array of tags) at $event.target.value
      const tags = $event.target._value;

      //check the checked prop at $event.target.checked
      if ($event.target.checked) {
        //if checked, we add the tags
        tags.forEach((tag) => {
          this.tagClicked(tag);
        });
      } else {
        //else, remove the tags
        tags.forEach((tag) => {
          this.removeFilter(tag);
        });
      }
    },
    tagClicked(tag) {
      tag.type = tag.id ? "resourceKeywords" : "search";

      //if clicked tag does not exist in current filters, add it
      if (
        -1 ===
        this.filters.findIndex(
          (test) => test.id === tag.id && test.text === tag.text
        )
      ) {
        this.filters.push(tag);
      }
      this.$nextTick(() => {
        let addedFilterButton;
        //count filter buttons
        let filterButtons = this.$el.querySelectorAll(
          ".js-resourceApp__header .selectedFilters__item"
        );

        //if more than 1 button, grab the second to last (last one is the 'clear all')
        if (filterButtons.length > 1)
          addedFilterButton = this.$el.querySelector(
            ".js-resourceApp__header .selectedFilters__item:nth-last-child(2) .selectedFilters__button"
          );
        //otherwise, just focus the only button
        else
          addedFilterButton = this.$el.querySelector(
            ".js-resourceApp__header .selectedFilters__button"
          );

        addedFilterButton.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        addedFilterButton.focus();
      });
    },
    navToTagResults(base, tag) {
      let filter = {
        text: tag.text,
        type: "resourceKeywords",
        id: tag.id,
      };
      let url = base + "?filters[]=" + JSON.stringify(filter);
      window.location.href = encodeURI(url);
    },
  },
});
